import { Quill } from 'react-quill';
const BaseImageFormat = Quill.import('formats/image');
const ImageFormatAttributesList = [
  'alt', 'height', 'width', 'style'
];
export class ImageFormat extends BaseImageFormat {
  public static formats(domNode) {
    return ImageFormatAttributesList.reduce((formats, attribute) => {
      if (domNode.hasAttribute(attribute)) {
        formats[attribute] = domNode.getAttribute(attribute);
      }
      return formats;
    }, {});
  }
  public format(name, value) {
    if (ImageFormatAttributesList.indexOf(name) > -1) {
      if (value) {
        this.domNode.setAttribute(name, value);
      } else {
        this.domNode.removeAttribute(name);
      }
    } else {
      super.format(name, value);
    }
  }
}